import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserProfileAvatarComponent } from './user-profile-avatar.component';

@NgModule({
  declarations: [UserProfileAvatarComponent],
  imports: [CommonModule],
  exports: [UserProfileAvatarComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UserProfileAvatarModule { }
